import { RagIndex } from '@/core/indexesEnum';
import { ChatAssistant } from './assistant-types';
import { SuggestionsCategory } from './chat.models';
import { BaseMessage } from './messages';

export class Conversation {
  id?: string;
  title: string | undefined;
  dateTime: Date;
  messages: BaseMessage[];
  assistant: ChatAssistant;
  ragIndex: RagIndex;
  suggestions?: SuggestionsCategory[];
  pickle?: string;

  constructor(
    assistant: ChatAssistant,
    ragIndex: RagIndex,
    date: Date = new Date(),
    id?: string
  ) {
    if (id) {
      this.id = id;
    }

    this.title = undefined;
    this.dateTime = date;
    this.messages = [];
    this.assistant = assistant;
    this.ragIndex = ragIndex;
  }

  public addMessage(message: BaseMessage): void {
    if (!this.title) {
      this.title = message.text;
    }

    this.messages.push({
      dateTime: new Date(),
      ...message
    });
  }

  public static fromConversation(conversation: Conversation) {
    const newConversation = new Conversation(
      conversation.assistant,
      conversation.ragIndex,
      conversation.dateTime,
      conversation.id
    );
    newConversation.title = conversation.title;
    newConversation.messages = conversation.messages;
    return newConversation;
  }

  public copyFrom(conversation: Conversation): void {
    this.id = conversation.id;
    this.title = conversation.title;
    this.dateTime = conversation.dateTime;
    this.messages = conversation.messages;
    this.assistant = conversation.assistant;
    this.ragIndex = conversation.ragIndex;
    this.suggestions = conversation.suggestions;
    this.pickle = conversation.pickle;
  }
}
export class ConversationHeaderData {
  loading: boolean;
  showNewConversation: boolean;
  showHistory: boolean;

  constructor(
    loading: boolean = false,
    showNewConversation: boolean = false,
    showHistory: boolean = false
  ) {
    this.loading = loading;
    this.showNewConversation = showNewConversation;
    this.showHistory = showHistory;
  }
}
